var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import history from 'helpers/History';
import { Table } from '../../../components';
import { T } from '../../../helpers/i18n';
var HeadboardsTable = /** @class */ (function (_super) {
    __extends(HeadboardsTable, _super);
    function HeadboardsTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleCreate = function () {
            history.push('/headboards/create');
        };
        _this.handleSelectItem = function (value) {
            history.push("/headboards/".concat(value.id));
        };
        _this.mapea = function (headboards) {
            if (!headboards)
                return [];
            var temp = headboards.map(function (value) { return value; });
            return temp.map(function (address) {
                address.status = !address.disabled_at ? T('enabled') : "".concat(T('disabled'));
                return address;
            });
        };
        return _this;
    }
    HeadboardsTable.prototype.render = function () {
        var headboards = this.props.headboards;
        var headers = ['title', 'subtitle', 'line1', 'line2', 'telephone', 'status'];
        var mapeado = this.mapea(headboards);
        var filters = [
            {
                name: 'all',
                filter: function (item) { return true; }
            },
            {
                name: 'actives',
                filter: function (item) { return item.disabled_at === null; }
            },
            {
                name: 'disabled',
                filter: function (item) { return item.disabled_at !== null; }
            },
        ];
        console.log('mapeado: ', mapeado);
        return (React.createElement(Table, { filters: filters, items: mapeado, header: headers, onSelectItem: this.handleSelectItem, onCreate: this.handleCreate, keyExtractor: function (item) { return String(item.id); }, loading: !headboards }));
    };
    HeadboardsTable = __decorate([
        inject('store'),
        loading(function (props) {
            return [
                props.store.headboardStore.read().then(function (headboards) { return ({ headboards: headboards }); }),
            ];
        }),
        observer
    ], HeadboardsTable);
    return HeadboardsTable;
}(Component));
export default HeadboardsTable;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Headboards/container/HeadboardsTable.tsx
// module id = 1596
// module chunks = 0